
import React, { useEffect, useRef } from 'react'

import { composeType, SystemMessageIcon } from '../../utils/systemMessage'
import { MessageProps } from '../../../MessageDisplayArea'
import MessageTime from '../MessageTime'

// eslint-disable-next-line object-curly-newline
const SystemMessage: React.FC<MessageProps> = props => {
  const {
    message: { subtype, renderText },
    common: { onScrollDown },
  } = props
  const messageChild = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (subtype === 'file') {
      const img = messageChild.current?.querySelector('img');

      if (img) {
        img.onload = () => {
          onScrollDown();
          img.onload = null;
        };
      }
    }
  });

  return (
    <div className={composeType(subtype)}>
      <div className="message-text" ref={messageChild}>
        {<SystemMessageIcon subtype={subtype} />}
        {<MessageTime {...props} />}
        {renderText('span')}
      </div>
    </div>
  );
};

export default SystemMessage
